import DashboardLayout from "@/components/DashboardLayout";
import Users from "./Users";

const UsersWrapper = () => {
  return (
    <DashboardLayout>
      <Users />
    </DashboardLayout>
  );
};

export default UsersWrapper;
